import { useEffect, useRef, useState } from "react";

const VideoFeed = ({ id, stream }) => {
  const ref = useRef();

  useEffect(() => {
    if (ref.current) ref.current.srcObject = stream;
  }, [stream]);

  return (
    <div>
      <h3>{id}</h3>
      <video ref={ref} autoPlay playsInline controls style={{ width: "300px" }} />
    </div>
  );
};

function ExamAdmin() {
  const socket = useRef(null);
  const peers = useRef({});
  const [streams, setStreams] = useState({});

  useEffect(() => {
    socket.current = new WebSocket("ws://192.168.40.1:5000"); // 🔴 SAME IP

    socket.current.onopen = () => {
      socket.current.send(JSON.stringify({ role: "admin" }));
    };

    socket.current.onmessage = async (event) => {
      const msg = JSON.parse(event.data);

      if (msg.studentDisconnected) {
        const id = msg.studentDisconnected;
        peers.current[id]?.close();
        delete peers.current[id];
        setStreams(prev => {
          const copy = { ...prev };
          delete copy[id];
          return copy;
        });
        return;
      }

      if (msg.offer) {
        const studentId = msg.studentId;

        if (peers.current[studentId]) return;

        const peer = new RTCPeerConnection({
          iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
        });

        peers.current[studentId] = peer;

        peer.ontrack = (e) => {
          setStreams(prev => ({ ...prev, [studentId]: e.streams[0] }));
        };

        peer.onicecandidate = (e) => {
          if (e.candidate) {
            socket.current.send(JSON.stringify({
              candidate: e.candidate,
              toStudentId: studentId
            }));
          }
        };

        await peer.setRemoteDescription(new RTCSessionDescription(msg.offer));
        const answer = await peer.createAnswer();
        await peer.setLocalDescription(answer);

        socket.current.send(JSON.stringify({ answer, toStudentId: studentId }));
      }

      if (msg.candidate && msg.from) {
        const peer = peers.current[msg.from];
        if (peer) {
          await peer.addIceCandidate(new RTCIceCandidate(msg.candidate));
        }
      }
    };

    return () => {
      socket.current.close();
      Object.values(peers.current).forEach(p => p.close());
    };
  }, []);

  return (
    <div>
      <h1>Admin</h1>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, 300px)", gap: "10px" }}>
        {Object.keys(streams).map(id => (
          <VideoFeed key={id} id={id} stream={streams[id]} />
        ))}
      </div>
    </div>
  );
}

export default ExamAdmin;
